import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {StateService} from "./state.service";
import {UserStatus} from "../models/user";

@Injectable({
  providedIn: 'root'
})
class UserAuthGuard {
  environment!: string;

  constructor(private router: Router, private stateService:StateService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.environment = document.location && document.location.host.substr(3, 4);

    if (this.stateService.isLoggedIn) {
      return true;
    } else {
      this.stateService.redirectUrl = state.url;
      this.router.navigate(['/unauthorized'] );
      return false;
    }

  }
}

export const UserAuthGuardService: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(UserAuthGuard).canActivate(next, state);
}
